import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import { Box, Divider, IconButton, Modal } from '@mui/material';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import CloseIcon from '@mui/icons-material/Close';
import ThemeColor from '../../theme/ThemeColor';

const dialogStyle = {
  position: 'fixed',
  right: 20,
  top: 20,
  backgroundColor: 'transparent',
  boxShadow: 'none'
};

export default function NotificationModal({
  open,
  notifications,
  setOpen,
  onClose,
  setNotifications,
  handleSingleNotificationClose
}) {
  const [selectedNotification, setSelectedNotification] = useState(null);

  const handleClose = () => {
    onClose();
  };

  const handleOpenPreview = (notification) => {
    setSelectedNotification(notification);
  };

  const handleClosePreview = () => {
    if (selectedNotification?._id) {
      handleSingleNotificationClose(selectedNotification._id);
    }
    setSelectedNotification(null);
  };

  const handleMarkAllAsRead = () => {
    const updated = notifications.map((item) => ({ ...item, isRead: true }));
    setNotifications(updated); // update local state
  };


  return (
    <>
      <Dialog onClose={handleClose} open={open} PaperProps={{ style: dialogStyle }}>
        <Box
          sx={{
            backgroundColor: '#fff',
            color: '#333',
            width: '360px',
            mt: 1,
            borderRadius: '12px',
            overflowY: 'auto',
            maxHeight: '420px',
            mb: '6px',
            boxShadow: 3,
            p: 1.2,
            transition: 'all 0.3s ease-in-out'
          }}
        >
          {notifications?.length === 0 ? (
            <Box
              sx={{
                py: 3,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <Typography sx={{ color: '#FF5A5A', fontWeight: 600, fontSize: '16px' }}>
                No Notifications Available!
              </Typography>
            </Box>
          ) : (
            <>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                  pr: 1.5,
                  mb: 1
                }}
              >
                <Typography
                  onClick={handleMarkAllAsRead}
                  sx={{
                    fontWeight: 600,
                    fontSize: '14px',
                    cursor: 'pointer',
                    color: ThemeColor.palette.BrandColor,
                    '&:hover': {
                      textDecoration: 'underline'
                    }
                  }}
                >
                  Mark All as Read
                </Typography>

              </Box>
              <Divider />
              {notifications.map((noti) => (
                <Box
                  key={noti._id}
                  onClick={() => handleOpenPreview(noti)}
                  sx={{
                    display: 'flex',
                    p: 1,
                    mb: 1,
                    gap: 1.5,
                    alignItems: 'flex-start',
                    borderRadius: '8px',
                    background: !noti.isRead ? ThemeColor.palette.backgroundColor : '#F8F8F8',
                    cursor: 'pointer',
                    transition: 'background 0.3s ease',
                    '&:hover': {
                      backgroundColor: '#ECECEC'
                    }
                  }}
                >
                  <Box sx={{ mt: 0.5 }}>
                    <NotificationsNoneIcon sx={{ color: '#04AB44' }} />
                  </Box>
                  <Box>
                    <Typography sx={{ fontWeight: 600, fontSize: '15px', color: '#04AB44' }}>
                      {noti.title}
                    </Typography>
                    <Typography sx={{ fontSize: '14px', color: '#555' }}>
                      {noti.message}
                    </Typography>
                  </Box>
                </Box>
              ))}
            </>
          )}
        </Box>
      </Dialog>

     {/* === POPUP FOR SINGLE NOTIFICATION === */}
<Modal open={!!selectedNotification} onClose={() => setSelectedNotification(null)}>
  <Box
    sx={{
      width: 460,
      bgcolor: '#fefefe',
      boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
      px: 4,
      py: 3,
      borderRadius: '12px',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      transition: 'all 0.3s ease-in-out',
      border: '1px solid #E0E0E0',
      animation: 'fadeIn 0.3s ease-in-out',
      '@keyframes fadeIn': {
        from: {
          opacity: 0,
          transform: 'scale(0.95) translate(-50%, -50%)'
        },
        to: {
          opacity: 1,
          transform: 'scale(1) translate(-50%, -50%)'
        }
      }
    }}
  >
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <Typography variant="h6" sx={{ fontWeight: 700, fontSize: '18px', color: '#333' }}>
        {selectedNotification?.title}
      </Typography>
      <IconButton
        onClick={handleClosePreview}
        sx={{
          backgroundColor: '#F5F5F5',
          borderRadius: '8px',
          '&:hover': {
            backgroundColor: '#E0E0E0'
          }
        }}
      >
        <CloseIcon sx={{ fontSize: 20 }} />
      </IconButton>
    </Box>

    <Divider sx={{ my: 2 }} />

    <Typography
      sx={{
        fontSize: '15.5px',
        color: '#555',
        lineHeight: 1.6,
        textAlign: 'justify'
      }}
    >
      {selectedNotification?.message}
    </Typography>
  </Box>
</Modal>


    </>
  );
}
